import http from './http'

export default {
  eventTypes: () => http.get('/v2/event-types'),
  create: (draftId, data) => http.post(`/v2/drafts/${draftId}/events`, data, { silent: true }),
  getEdit: (draftId, eventId) => http.get(`/v2/drafts/${draftId}/events/${eventId}/edit`),
  update: (draftId, eventId, data) => http.put(`/v2/drafts/${draftId}/events/${eventId}`, data, { silent: true }),
  // localSuccess: the caller shows the result itself (next to the event); without it the http client
  // would also push it to the page-top alert and scroll the page up.
  destroy: id => http.delete(`/v2/events/${id}`, { silent: true, localSuccess: true }),
  reorder: (draftId, ids) => http.patch(`/v2/drafts/${draftId}/events/reorder`, { ids }, { silent: true, localSuccess: true }),
  nominationsDashboard: draftId => http.get(`/v2/drafts/${draftId}/events/nominations-dashboard`),
  lock: (id, isLocked) => http.patch(`/v2/events/${id}/lock`, { is_locked: isLocked }, { silent: true, localSuccess: true }),
  deleteSponsorLogo: id => http.delete(`/v2/events/${id}/sponsor-logo`, { silent: true }),
  split: id => http.post(`/v2/events/${id}/split`, {}, { silent: true, localSuccess: true })
}



// WEBPACK FOOTER //
// ./src/services/api/events.js